/**
 * Copyright © 2022 Anagog Ltd. All rights reserved.
 */

import { NativeModules } from 'react-native';
const { JedAIModule } = NativeModules;

export class AnagogLogger {
    static info(message: string) {
        console.log(message);
        JedAIModule.logInfo(message);
    }

    static error(message: string) {
        console.error(message);
        JedAIModule.logError(message);
    }
}